export default "__VITE_ASSET__4Y4tJnIk__"